import React from "react"

import * as customersSectionStyles from "../styles/CustomersSection.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

export default function StoriesSection(props) {
  const { content } = props

  /* const title = ChildSelector.select(
    content,
    `intro-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  ) */

  const cards = ChildSelector.select(
    content,
    `customers-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY
  ).map(card => ({
    holder: card,
    content: ChildSelector.select(
      card,
      `customers-content`,
      ChildSelector.SELECTOR_TYPE.ARRAY
    ).map(c => c.innerHTML),
    author: ChildSelector.select(
      card,
      `customers-author`,
      ChildSelector.SELECTOR_TYPE.TEXT
    ),
    authorPosition: ChildSelector.select(
      card,
      `author-position`,
      ChildSelector.SELECTOR_TYPE.TEXT
    ),
    company: ChildSelector.select(
      card,
      `author-company`,
      ChildSelector.SELECTOR_TYPE.TEXT
    ),
  }))

  return (
    <>
      <div
        className={`row justify-content-center ${props.className} ${customersSectionStyles.wrapper}`}
      >
        <TwoColumnHeroWithImageRight
          contentClass={customersSectionStyles.content}
          imageHolder={content}
          imageSelector={`customers-media`}
          imageClass={customersSectionStyles.backgroundImage}
          className={customersSectionStyles.innerWrapper}
          mode={CONTAINMENT_MODE.normal}
        >
          <div className={`col-12 ${customersSectionStyles.contentGroup}`}>
            {cards &&
              cards.map((c, idx) => (
                <span
                  className={`${customersSectionStyles.customersCard}`}
                  key={idx}
                >
                  <p className={`${customersSectionStyles.content}`}>
                    {c.content && c.content.map(t => (
                      <span>{t}</span>
                    ))}
                  </p>
                  <div className={`${customersSectionStyles.authorInfo}`}>
                    <h5 className={`${customersSectionStyles.authorName}`}>
                      {c.author}
                    </h5>
                    <h6 className={`${customersSectionStyles.authorPosition}`}>
                      {c.authorPosition}
                    </h6>
                    <p className={`${customersSectionStyles.companyName}`}>
                      {c.company}
                    </p>
                  </div>
                </span>
              ))}
          </div>
        </TwoColumnHeroWithImageRight>
      </div>
    </>
  )
}
